<template>
  <BootstrapModal class="AddTranslation"
    v-on="$listeners"

    @save="saveTranslation"
  >
    <div>
      <FormSelect v-model="$v.lang.$model"
        class="sm form-element"
        id="lang"
        label="Lang"

        :options="translationOptions"
      />

      <FormInput
        class="form-element"
        v-model="$v.category.$model"

        id="lang"
        label="Categorie"

        :vuelidate="$v"
        fieldName="lang"
      />
    </div>

    <template #close>
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="goBack">Sluiten</button>
    </template>

    <template #title>
      {{ item ? "Vertaling bewerken" : "Vertaling toevoegen" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"
import FormSelect from "/src/components/Inputs/FormSelect.vue"
import FormTextarea from "/src/components/Inputs/FormTextarea.vue"

import { required } from "vuelidate/lib/validators"
import table from "src/mixins/tableFieldOptions"

export default {
  mixins: [table],
  components: {
    BootstrapModal,
    FormInput,
    FormTextarea,
    FormSelect,
  },
  validations: {
    category: {
      required,
    },
    lang: {
      required,
    },
  },
  props: {
    endpoint: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: false,
    },
    callback: {
      type: Function,
      required: false,
    },
    goBack: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      category: "",
      lang: "",
    }
  },
  created() {
    const item = this.item
    if (item) {
      this.$v.lang.$model = item.lang
      this.$v.category.$model = item.translation.category
    }
  },
  methods: {
    async saveTranslation() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        language: this.$v.lang.$model,
        translation: {
          category: this.$v.category.$model,
        },
      }

      await this.$handlePromise(async () => {
        await this.axios.post(this.endpoint, payload)

        this.callback && (await this.callback())
        if (this.goBack) this.goBack()
        
        this.$success("Vertaling succesvol toegevoegd!")
      })
    },
  },
}

</script>

<style scoped>

.AddTranslation {
  flex-basis: 450px;
}

</style>
